import { Adapter as t } from "../../adapter.js";
import { BaseTimeSlotModel as r } from "./baseTimeSlot.model.js";
class l extends t {
  adapt(e) {
    return new r({
      fullDay: e.full_day,
      endTime: e.end_time,
      startTime: e.start_time,
      weekDays: e.week_days,
      timezone: e.timezone
    });
  }
  serialize(e) {
    throw new Error("Method not implemented.");
  }
}
export {
  l as BaseTimeSlotAdapter
};
//# sourceMappingURL=baseTimeSlot.adapter.js.map
